import { takeEvery } from 'redux-saga/effects';
import { notification } from 'antd';
import i18n from '../i18n';

function showSuccessMessage(action: any) {
  try {
    const {
      snackbarRequestMessage: { label, timeout, title, placement },
    } = action;

    notification.open({
      message: title ? i18n.t(title) : i18n.t('common:requestMessageTitle'),
      description: label && i18n.t(label),
      duration: timeout,
      placement,
    });
  } catch (error) {}
}

export default function* watchRequests() {
  yield takeEvery<any>(
    (action) => /_REQUEST$/.test(action.type) && action.snackbarRequestMessage,
    showSuccessMessage
  );
}
